<template>
    <v-container>
        <!-- div for help to place filter card -->
        <div class="mt-n16 white--text">.</div>

        <!-- filter -->
        <v-card class="mt-0 py-5" elevation="3">
            <v-row align="center" class="px-5">
                <v-col cols="auto">
                    <v-text-field
                        v-model="filter.name"
                        label="Naam"
                        clearable
                        hide-details
                        dense
                        class="subtitle-2"
                    ></v-text-field>
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <v-btn rounded color="primary" @click="addUser"
                        >Toevoegen</v-btn
                    >
                </v-col>
            </v-row>
        </v-card>

        <!-- data table card -->
        <v-card class="mt-3" elevation="3">
            <v-card-text class="pb-3">
                <v-data-table
                    :headers="headers"
                    :loading="$apollo.queries.tenantStaffGroups.loading"
                    :items="tenantStaffGroups.edges"
                    :expanded.sync="expanded"
                    item-key="node.id"
                    sort-by="node.name"
                    :sort-desc="false"
                    loading-text="Een ogenblik geduld aub..."
                    hide-default-footer
                    disable-pagination
                >
                    <!-- data table progress bar -->
                    <template v-slot:progress class="px-0 mx-0">
                        <v-progress-linear
                            absolute
                            height="2"
                            indeterminate
                        ></v-progress-linear>
                    </template>

                    <!-- no data availabel -->
                    <template slot="no-data">
                        <div>Geen gegevens beschikbaar</div>
                    </template>

                    <!-- email-->
                    <template v-slot:item.node.permissions="{ item }">
                        {{ item.node.permissions.length }}
                    </template>

                    <!-- acions -->
                    <template v-slot:item.action="{ item }">
                        <v-btn
                            :disabled="!me.isTenantAdmin"
                            icon
                            outlined
                            small
                            color="primary"
                            class="mr-2"
                            @click="editGroup(item.node)"
                        >
                            <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn
                            :disabled="!me.isTenantAdmin"
                            icon
                            outlined
                            small
                            color="error"
                            @click="deletingGroup(item.node)"
                        >
                            <v-icon small>delete</v-icon>
                        </v-btn>
                        <!-- <v-icon small @click="deletingPlant(item)">delete</v-icon> -->
                    </template>
                    <!-- expanded area -->
                    <!-- <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="px-5 py-5">
                            <v-subheader>Groepen</v-subheader>
                            <v-row
                                v-for="group in item.node.allGroups.edges"
                                :key="group.node.id"
                            >
                                <v-col cols="6" sm="8" md="9">{{
                                    group.node.name
                                }}</v-col>
                            </v-row>
                        </td>
                    </template> -->
                </v-data-table>
            </v-card-text>

            <!-- infinit loading trigger -->
            <v-card-actions class="justify-center">
                <v-btn
                    v-if="hasMoreData"
                    v-intersect="onLoadMoreTriggerIntersect"
                    :disabled="!hasMoreData"
                    :loading="$apollo.queries.energyInvoices.loading"
                    text
                    class="mb-5"
                    @click="loadMore"
                >
                    Meer
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Delete Tenant Staff Dialog -->
        <DeleteDialog
            :dialog.sync="deleteDialog"
            :item="deletedTenantStaffGroup"
            v-on:confirmed="onDeleteConfirmed"
        >
            <template v-slot:title
                >Verwijderen -
                {{
                    deletedTenantStaffGroup ? deletedTenantStaffGroup.name : ""
                }}</template
            >
            <template v-slot:content
                >Weet u zeker dat u deze groep wilt verwijderen?</template
            >
        </DeleteDialog>

        <GroepForm
            :dialog.sync="groupDialog"
            :object.sync="editedItem"
            v-on:done="refetchDate"
        ></GroepForm>
    </v-container>
</template>


<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import DeleteDialog from "@/components/base/DeleteDialog.vue";
import GroepForm from "./forms/GroepForm.vue";

export default {
    title: "Groepen",
    components: { DeleteDialog, GroepForm },

    apollo: {
        tenantStaffGroups: {
            query: gql`
                query tenantStaffGroups(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $name: String
                    $orderBy: String
                ) {
                    tenantStaffGroups(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        name_Icontains: $name
                        orderBy: $orderBy
                    ) {
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                name
                                accounts {
                                    totalCount
                                }
                                staffs {
                                    totalCount
                                }
                                permissions
                            }
                        }
                    }
                }
            `,
            variables() {
                return this.filter;
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first", // this setting can avoid query again after fetchMore
            update: data => data.tenantStaffGroups,
            watchLoading(isLoading) {
                this.$emit("loading", isLoading);
            },
            debounce: 500,
            skip() {
                return this.me.isStaff;
            }
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            groupDialog: false,
            deleteDialog: false,
            editedItem: null,
            deletedTenantStaffGroup: null,

            // graphql query filter
            filter: {
                first: 25,
                after: null,
                name: null,
                orderBy: "name"
            },
            expanded: [],
            tenantStaffGroups: {},

            // infinite loading trigger
            shouldLoadMore: false,

            headers: [
                {
                    text: "Name",
                    align: "left",
                    value: "node.name",
                    sortable: true
                },
                {
                    text: "Rechten",
                    value: "node.permissions",
                    sortable: true
                },
                {
                    text: "Locaties",
                    align: "left",
                    value: "node.accounts.totalCount",
                    sortable: true
                },
                {
                    text: "Gebruikers",
                    value: "node.staffs.totalCount",
                    sortable: true
                },
                {
                    text: "",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
                // { text: "", value: "data-table-expand" }
            ]
        };
    },

    computed: {
        me() {
            return this.$store.state.user.me || {};
        },
        // infinite loading
        hasMoreData() {
            return this.tenantStaffGroups?.pageInfo?.hasNextPage;
        }
    },
    watch: {
        filter: {
            deep: true,

            handler() {
                this.refetchDate();
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {},
    methods: {
        // infinite loading trigger
        onLoadMoreTriggerIntersect(entries) {
            this.shouldLoadMore = entries[0].isIntersecting;

            if (
                this.shouldLoadMore &&
                this.tenantStaffGroups?.pageInfo?.hasNextPage
            ) {
                this.loadMore();
            }
        },
        refetchDate() {
            // use timeout to debouce
            if (this.timeout) clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.$apollo.queries.tenantStaffGroups.refetch(this.filter);
            }, 800); // delay
        },
        loadMore() {
            if (this.tenantStaffGroups?.pageInfo?.hasNextPage) {
                this.$apollo.queries.tenantStaffGroups.fetchMore({
                    variables: {
                        after: this.tenantStaffGroups.pageInfo.endCursor
                    }
                });
            }
        },

        addUser() {
            this.editedItem = null;
            this.groupDialog = true;
        },
        editGroup(user) {
            this.editedItem = JSON.parse(JSON.stringify(user));
            this.groupDialog = true;
        },
        deletingGroup(item) {
            this.deletedTenantStaffGroup = item;
            this.deleteDialog = true;
        },
        onDeleteConfirmed(item) {
            if (item) {
                const payload = {
                    id: item.id
                };

                this.$apollo
                    .mutate({
                        // Query
                        mutation: gql`
                            mutation deleteTenantStaffGroup(
                                $input: DeleteTenantStaffGroupInput!
                            ) {
                                deleteTenantStaffGroup(input: $input) {
                                    tenantStaffGroup {
                                        id
                                        name
                                        accounts {
                                            totalCount
                                        }
                                        staffs {
                                            totalCount
                                        }
                                        permissions
                                    }
                                }
                            }
                        `,
                        // Parameters
                        variables: {
                            input: {
                                ...payload
                            }
                        }
                    })
                    .then(() => {
                        this.deleteDialog = false;
                        this.refetchDate();

                        // show snackbar
                        const payload = {
                            color: "success",
                            message: "De groep is verwijderd!"
                        };
                        this.$store.dispatch("snackbar/showMessage", payload);
                    })
                    .catch(error => {
                        // Error
                        console.error(error);
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>
